import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, UserPlus, Loader2 } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

export default function PlusNewCustomer() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ nome: "", cognome: "", cellulare: "", data_nascita: "", email: "", card_uid: "" });
  const [privacy, setPrivacy] = useState(false);
  const [profiling, setProfiling] = useState(false);
  const [marketing, setMarketing] = useState(false);
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = { ...form, privacy_consent: privacy, profiling_consent: profiling, marketing_consent: marketing };
      Object.keys(payload).forEach((k) => payload[k] === "" && delete payload[k]);
      const { data } = await api.post("/plus/customers", payload);
      toast.success("Cliente creato");
      navigate(`/customers/${data.customer.id}`);
    } catch (err) {
      toast.error(apiError(err));
    } finally { setLoading(false); }
  };

  const field = (label, key, type = "text", required = false) => (
    <div>
      <label className="block text-sm text-zinc-400 mb-2">{label}{required && " *"}</label>
      <input
        data-testid={`plus-new-${key}`}
        type={type} value={form[key]} onChange={set(key)} required={required}
        className="w-full h-13 px-4 py-3 rounded-2xl bg-zinc-800 border border-zinc-700 text-white focus:outline-none focus:border-sky-400 transition-colors"
      />
    </div>
  );

  return (
    <div className="min-h-screen bg-zinc-950 text-white">
      <div className="max-w-2xl mx-auto px-6 py-8">
        <button data-testid="plus-new-back" onClick={() => navigate("/")} className="flex items-center gap-2 text-zinc-400 hover:text-white mb-6 transition-colors">
          <ArrowLeft className="w-5 h-5" /> Home
        </button>
        <h1 className="font-display text-3xl font-bold mb-6 flex items-center gap-3"><UserPlus className="w-8 h-8 text-sky-400" /> Nuovo cliente PLUS</h1>
        <form onSubmit={submit} className="space-y-4 bg-zinc-900 border border-zinc-800 rounded-3xl p-6">
          <div className="grid grid-cols-2 gap-4">
            {field("Nome", "nome", "text", true)}
            {field("Cognome", "cognome", "text", true)}
          </div>
          {field("Cellulare", "cellulare", "tel", true)}
          <div className="grid grid-cols-2 gap-4">
            {field("Data di nascita", "data_nascita", "date")}
            {field("Email", "email", "email")}
          </div>
          {field("UID tessera NFC (opzionale)", "card_uid")}
          <div className="space-y-2 pt-2 border-t border-zinc-800">
            <label className="flex items-center gap-3 text-sm text-zinc-300">
              <input data-testid="plus-new-privacy" type="checkbox" checked={privacy} onChange={(e) => setPrivacy(e.target.checked)} className="w-5 h-5 accent-sky-500" /> Consenso privacy
            </label>
            <label className="flex items-center gap-3 text-sm text-zinc-300">
              <input data-testid="plus-new-profiling" type="checkbox" checked={profiling} onChange={(e) => setProfiling(e.target.checked)} className="w-5 h-5 accent-sky-500" /> Consenso profilazione
            </label>
            <label className="flex items-center gap-3 text-sm text-zinc-300">
              <input data-testid="plus-new-marketing" type="checkbox" checked={marketing} onChange={(e) => setMarketing(e.target.checked)} className="w-5 h-5 accent-sky-500" /> Consenso marketing
            </label>
          </div>
          <button data-testid="plus-new-submit" type="submit" disabled={loading}
            className="w-full h-14 rounded-2xl bg-sky-500 hover:bg-sky-400 font-bold text-lg flex items-center justify-center gap-2 transition-colors disabled:opacity-60">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <UserPlus className="w-5 h-5" />} Crea cliente
          </button>
        </form>
      </div>
    </div>
  );
}
